(function() {
  var BaseHandler, DetailOutput, ReportsRxAnalysisSummary,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DetailOutput = App.loadClass('core::reports/DetailOutput');

  BaseHandler = App.loadClass('core::reports/BaseHandler');

  ReportsRxAnalysisSummary = App.loadClass('portal::handlers/reports/ReportsRxAnalysisSummary');

  exports.ReportsNitrogenRxAnalysisSubHandler = (function(superClass) {
    extend(ReportsNitrogenRxAnalysisSubHandler, superClass);

    function ReportsNitrogenRxAnalysisSubHandler() {
      return ReportsNitrogenRxAnalysisSubHandler.__super__.constructor.apply(this, arguments);
    }

    ReportsNitrogenRxAnalysisSubHandler.prototype.init = function() {
      this.layoutSelector = '#reports_nitrogen_rx_analysis_tab';
      this.excelUrl = 'backend/portal/reports/nitrogen-rx-analysis/excel';
      this.filterUrl = 'backend/portal/reports/nitrogen-rx-analysis/filters';
      return this.initFilters();
    };

    ReportsNitrogenRxAnalysisSubHandler.prototype.initFilters = function() {
      this.resetFilters();
      this.parent.filters.importGroup({
        name: 'Rx Analysis Filters',
        filters: [
          {
            name: 'crops',
            display_name: 'Crop',
            "class": 'dropup'
          }, {
            name: 'advisor',
            display_name: 'Advisor',
            "class": 'dropup'
          }, {
            name: 'downloaded_by',
            display_name: 'Downloaded By',
            "class": 'dropup'
          }, {
            name: 'service_level',
            display_name: 'Service Level',
            "class": 'dropup'
          }, {
            name: 'output_type',
            display_name: 'Output Type',
            control_type: 'option',
            deletable: false,
            values: [
              {
                key: 'detail',
                value: 'Detail'
              }, {
                key: 'summary',
                value: 'Summary'
              }
            ],
            selected_values: [
              {
                key: 'summary',
                value: 'Summary'
              }
            ]
          }
        ]
      });
      return this.setDefaultsAndRun();
    };

    ReportsNitrogenRxAnalysisSubHandler.prototype.destroy = function() {
      this.parent.filters.enableGroup('Operation Filters');
      this.parent.filters.removeGroup('Rx Analysis Filters');
      return ReportsNitrogenRxAnalysisSubHandler.__super__.destroy.call(this);
    };

    ReportsNitrogenRxAnalysisSubHandler.prototype.beforeApply = function() {
      var filters;
      filters = this.parent.filters.jsonize();
      if (filters.filters.output_type[0].key === 'detail') {
        this.layoutUrl = 'backend/portal/reports/nitrogen-rx-analysis/table/detail';
        this.printUrl = 'backend/portal/reports/nitrogen-rx-analysis/print/detail';
        return this.currentOutput = new DetailOutput(this, this.parent, 'auto', {
          sAjaxSource: 'backend/portal/reports/nitrogen-rx-analysis/output/detail'
        });
      } else {
        this.layoutUrl = 'backend/portal/reports/nitrogen-rx-analysis/output/summary';
        this.printUrl = 'backend/portal/reports/nitrogen-rx-analysis/print/summary';
        return this.currentOutput = new ReportsRxAnalysisSummary(this, this.parent);
      }
    };

    return ReportsNitrogenRxAnalysisSubHandler;

  })(BaseHandler);

}).call(this);
